export default "__VITE_ASSET__2edbe79d__"